componentRegistryInstance.register('static', 'read', 'hrd.components.form.StaticComponent');

hrd.components.form.StaticComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.StaticComponent',
			verbose: true
		};
		this._super($.extend(true, {}, defaults, options));
	},

	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
	},

	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},

	setReadOnlyField: function(field, value, object, options) {
		// do nothing: do not call 'super'
	},

	resetReadOnlyField: function(field, options) {
		// do nothing: do not call 'super'
	}

});